import UnprotectedRoute from './UnprotectedRoute';

export default UnprotectedRoute;
